import {
  FETCH_BLOGS_REQUEST,
  FETCH_BLOGS_SUCCESS,
  FETCH_BLOGS_FAILURE,
  CREATE_BLOG_REQUEST,
  CREATE_BLOG_SUCCESS,
  CREATE_BLOG_FAILURE,
  UPDATE_BLOG_REQUEST,
  UPDATE_BLOG_SUCCESS,
  UPDATE_BLOG_FAILURE,
  DELETE_BLOG_REQUEST,
  DELETE_BLOG_SUCCESS,
  DELETE_BLOG_FAILURE,
} from "../actions/blogActions";

const initialState = {
  blogs: [],
  loading: false,
  error: null,
  createStatus: null,
  createMessage: null,
  updateStatus: null,
  deleteStatus: null,
};

const blogReducer = (state = initialState, action) => {
  switch (action.type) {

    case FETCH_BLOGS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_BLOGS_SUCCESS:
      return { ...state, loading: false, blogs: action.payload };

    case FETCH_BLOGS_FAILURE:
      return { ...state, loading: false, error: action.payload };



    case CREATE_BLOG_REQUEST:
      return { ...state, createStatus: null };

    case CREATE_BLOG_SUCCESS:
      return {
        ...state,
        createStatus: "success",
      };

    case CREATE_BLOG_FAILURE:
      return {
        ...state,
        createStatus: "failure",
        error: action.payload,
      };



    case UPDATE_BLOG_REQUEST:
      return { ...state, updateStatus: null };

    case UPDATE_BLOG_SUCCESS:
      return {
        ...state,
        updateStatus: "success",
      };

    case UPDATE_BLOG_FAILURE:
      return {
        ...state,
        updateStatus: "failure",
        error: action.payload,
      };



    case DELETE_BLOG_REQUEST:
      return { ...state, deleteStatus: null };

    case DELETE_BLOG_SUCCESS:
      return {
        ...state,
        blogs: state.blogs.filter((blog) => blog.id !== action.payload),
        deleteStatus: "success",
      };

    case DELETE_BLOG_FAILURE:
      return {
        ...state,
        deleteStatus: "failure",
        error: action.payload,
      };

    default:
      return state;
  }
};

export default blogReducer;